module.exports = __webpack_public_path__ + "assets/img/Logitech-G-Regional-Landing-Page-w540.440b7ef3.webp";